import "./MiniButton.scss";

const MiniButton = ({onClick, buttonText, pathTarget, download}) =>{
    const defaultPathData = {
        href: "#",
    };
    
    const pathData = {
        ...defaultPathData,
        href: pathTarget !== undefined ? pathTarget : defaultPathData.href,
    };
    

    return(
        <a href={pathData.href} className="mini-button" onClick={onClick}>
            {buttonText}
        </a>
    );
}

export default MiniButton;